import { render, staticRenderFns } from "./ElForm.vue?vue&type=template&id=353ddb54&"
import script from "./ElForm.vue?vue&type=script&lang=js&"
export * from "./ElForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353ddb54')) {
      api.createRecord('353ddb54', component.options)
    } else {
      api.reload('353ddb54', component.options)
    }
    module.hot.accept("./ElForm.vue?vue&type=template&id=353ddb54&", function () {
      api.rerender('353ddb54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/ElForm.vue"
export default component.exports